import { createCard } from "./create-card";
import { findCardByEmail, findCardByPipeId } from "./find-card";
import { updateCard } from "./update-card";

/**
 * Central de operações no card
 */
export async function saveCard({ params, config }) {

  const data = params?.body ?? params;
  const emailAddress = params.userEmail;
  const pipeId = data?.pipe_id;
  let json;
  let oldLead;
  if(pipeId) {
    console.log("FINDBYPIPEID")
    json = await findCardByPipeId({ pipeId, config });
    oldLead = json.data?.card;
  } else {
    json = await findCardByEmail({ emailAddress, config });
    oldLead = json.data?.findCards?.edges?.[0];
  }

  let result;
  if (oldLead == null) {
    result = await createCard({ data, config, emailAddress });
  } else {
    result = await updateCard({ 
      oldLead: oldLead, 
      data, 
      config 
    });
  }

  return {
    status: !(result?.errors?.length > 0 || result?.data?.errors?.length > 0),
    data: result?.data
  }
}
